import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1cdde372"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-box"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "teacher-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = {
  class: "teacher-name"
};
const _hoisted_7 = {
  class: "teacher-org"
};
const _hoisted_8 = {
  class: "teacher-intro"
};
const _hoisted_9 = {
  class: "right"
};
const _hoisted_10 = ["src"];
import SectionHeader from '../SectionHeader.vue';
import { ZhsSvgIcon } from 'zhs-component-library';
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const $utils = inject('$utils');
    const teacherList = ref([]);

    const handleDetail = id => {
      window.open(`/teacherDetailInfo.html?id=${id}&name=${props.menu.module_name}&menuId=${props.menu.menu_id}`);
    };

    const getTeacherList = async () => {
      const list = await $http.getHomeTeachers({
        num: props.menu.num,
        menu_id: props.menu.menu_id
      });
      console.log('名师', list);
      teacherList.value = list;
    };

    getTeacherList();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createVNode(SectionHeader, {
        title: __props.menu.module_name
      }, {
        default: _withCtx(() => [_createElementVNode("a", {
          href: `/teacherList.html?name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`
        }, "全部>", 8, _hoisted_2)]),
        _: 1
      }, 8, ["title"]), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherList.value, item => {
        return _openBlock(), _createElementBlock("li", {
          class: "teacher-item",
          key: item.id
        }, [_createElementVNode("div", {
          class: "teacher-info",
          onClick: $event => handleDetail(item.id)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("h4", _hoisted_6, _toDisplayString(item.teacher_name), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.organ_name + (item.title || '')), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(_unref($utils).getContentText(item.introduction)), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: item.teacher_avatar_url || require('@/assets/images/common/teacher_image.png'),
          class: "teacher-image",
          alt: ""
        }, null, 8, _hoisted_10)])], 8, _hoisted_4), _createVNode(_unref(ZhsSvgIcon), {
          name: "teacher_card",
          iconClass: "teacher-icon"
        })]);
      }), 128))])]);
    };
  }

};